module.exports = __webpack_public_path__ + "img/framework.74faa002.svg";